{
  "internalError": {
    "type": "error",
    "header": "Fehler",
    "body": "Die Operation ist leider fehlgeschlagen.",
    "button": "OK"
  },
  "loginFailed": {
    "type": "error",
    "header": "Anmeldung fehlgeschlagen",
    "body": "Anmeldung war leider derzeit nicht möglich. Bitte versuche es erneut oder setze dich mit uns in Verbindung.",
    "button": "OK"
  },
  "userRegistrationSuccessful": {
    "type": "success",
    "header": "Registrierung erfolgreich",
    "body": "Dein Benutzerkonto ist fertig. Du kannst dich nun anmelden.",
    "button": "OK"
  },
  "userRegistrationSuccessfulWithPassword": {
    "type": "success",
    "header": "Anmeldung erfolgreich",
    "body": "Dein Benutzerkonto ist fertig. Aus Sicherheitsgründen bitten wir dich, sich noch einmal einzuloggen.",
    "button": "OK"
  },
  "userConfirmationNotPossible": {
    "type": "error",
    "header": "Registrierung fehlgeschlagen",
    "body": "Wir konnten die Registrierung nicht abschließen. Bitte setze dich mit uns in Verbindung an support@monestry.de.",
    "button": "OK"
  },
  "pressOkToContinue": {
    "type": "warning",
    "header": "Fehler",
    "body": "Zum Fortfahren OK klicken.",
    "button": "OK"
  },
  "formIncomplete": {
    "type": "error",
    "header": "Formular ist noch unvollständig",
    "body": "Bitte ergänze alle Pflichtfelder.",
    "button": "Schliessen"
  },
  "nothingToSave": {
    "type": "success",
    "header": "Keine Änderungen",
    "body": "Keine Änderungen sind festgestellt, also nichts muss gespeichert werden.",
    "button": "Schliessen"
  },
  "localValidationFailed": {
    "type": "error",
    "header": "Wir haben Fehler festgestellt",
    "body": "Die Fehler sind nun in dem Spreadsheet rot gekennzeichnet. Bitte korrigiere diese Fehler und speichere erneut.",
    "button": "Schliessen"
  },
  "aboutToSave": {
    "type": "warning",
    "header": "Deine Daten werden geändert",
    "body": "Deine Daten werden unwiderruflich geändert. Bitte bestätige mit OK oder kehre mit Abbrechen zurück.",
    "button": "OK",
    "button2": "Abbrechen"
  },
  "saveCompleted": {
    "type": "success",
    "header": "Daten erfolgreich aktualisiert.",
    "body": "Deine Daten werden erfolgreich aktualisiert.",
    "button": "Schliessen"
  },
  "saveFailed": {
    "type": "error",
    "header": "Speichern fehlgeschlagen",
    "body": "Wir konnten leider die Änderungen nicht abspeichern. Bitte beachte die Fehlermeldungen.",
    "button": "Schliessen"
  },
  "fileUploadSuccessful": {
    "type": "success",
    "header": "Erfolg",
    "body": "Datei erfolgreich hochgeladen.",
    "button": "Schliessen"
  },
  "fileUploadFailed": {
    "type": "error",
    "header": "Fehler",
    "body": "Wir konnten leider die Datei nicht hochladen. Versuche bitte später erneut.",
    "button": "Schliessen"
  },
  "aboutToLoseData": {
    "type": "warning",
    "header": "Änderungen verwerfen?",
    "body": "Nach Verlassen des Edit-Modus gehen alle nicht gespeicherte Änderungen verloren. Bitte bestätige mit OK oder kehre mit Abbrechen zurück.",
    "button": "OK",
    "button2": "Abbrechen"
  },
  "abandonUpload": {
    "type": "warning",
    "header": "Änderungen verwerfen?",
    "body": "Du bist dabei, diese Datei zu verwerfen. Bitte bestätige mit OK oder kehre mit Abbrechen zurück.",
    "button": "OK",
    "button2": "Abbrechen"
  },
  "youAreAboutToDeleteAccount": {
    "type": "warning",
    "header": "Deine Daten werden gelöscht",
    "body": "Du bist dabei, das Konto samt allen Daten zu löschen. Bitte bestätige mit OK oder kehre mit Abbrechen zurück.",
    "button": "OK",
    "button2": "Abbrechen"
  },
  "youAreAboutToDeleteProject": {
    "type": "warning",
    "header": "Dieses Projekt wird gelöscht",
    "body": "Du bist dabei, das Projekt samt allen Transaktionen zu löschen. Ausgeführte Transaktionen werden nicht gelöscht. Bitte bestätige mit OK oder kehre mit Abbrechen zurück.",
    "button": "OK",
    "button2": "Cancel"
  },
  "youAreAboutToDeleteTransaction": {
    "type": "warning",
    "header": "Diese Transaktion wird gelöscht",
    "body": "Du bist dabei, diese Transaktion permanent zu löschen. Bitte bestätige mit OK oder kehre mit Abbrechen zurück.",
    "button": "OK",
    "button2": "Cancel"
  },
  "youAreAboutToDeleteValuation": {
    "type": "warning",
    "header": "Diese Bewertung wird gelöscht",
    "body": "Du bist dabei, diese Bewertung permanent zu löschen. Bitte bestätige mit OK oder kehre mit Abbrechen zurück.",
    "button": "OK",
    "button2": "Cancel"
  },
  "closeAccountDetails": {
    "type": "warning",
    "header": "Änderungen verwerfen?",
    "body": "Ggf. getätigte Änderungen werden verworfen. Bitte bestätige mit OK oder kehre mit Abbrechen zurück.",
    "button": "OK",
    "button2": "Abbrechen"
  },
  "Invalid currency code": {
    "type": "error",
    "header": "Währungs-Code ungültig",
    "body": "Bitte einen gültigen Währungs-Code eingeben.",
    "button": "Schliessen"
  },
  "Transaction date must be in a date format": {
    "type": "error",
    "header": "Transaktionsdatum ungültig",
    "body": "Transkationsdatum muss im Datumsformat sein (DD-MM-JJJJ).",
    "button": "Schliessen"
  },
  "Transaction date is required": {
    "type": "error",
    "header": "Transaktionsdatum fehlt",
    "body": "Datum ist ein Pflichtfeld.",
    "button": "Schliessen"
  },
  "Transaction party must be shorter than 100 characters": {
    "type": "error",
    "header": "Transaktionspartei zu lang",
    "body": "Transkationspartei darf nicht länger als 100 Zeichen sein.",
    "button": "Schliessen"
  },
  "Transaction party is required": {
    "type": "error",
    "header": "Transaktionspartei fehlt.",
    "body": "Transaktionspartei (Sender oder Empfänger) wird für alle Transaktionen benötigt.",
    "button": "Schliessen"
  },
  "Transaction description must be shorter than 1000 characters": {
    "type": "error",
    "header": "Transaktionsbeschreibung zu lang",
    "body": "Transaktionsbeschreibung muss 1000 Zeichen nicht überschreiten.",
    "button": "Schliessen"
  },
  "Transaction description is required": {
    "type": "error",
    "header": "Transaktionsbeschreibung fehlt",
    "body": "Transaktionsbeschreibung ist ein Pflichtfeld.",
    "button": "Schliessen"
  },
  "Amount must be a number": {
    "type": "error",
    "header": "Betrag muss ein eine Zahl sein",
    "body": "Alle Transaktionsbeträge müssen Zahlen sein und dürfen keine Buchstaben enthalten.",
    "button": "Schliessen"
  },
  "Amount is required": {
    "type": "error",
    "header": "Transaktionsbetrag fehlt",
    "body": "Transaktionsbetrag ist ein Pflichtfeld.",
    "button": "Schliessen"
  },
  "Currency code is required": {
    "type": "error",
    "header": "Währungs-Code fehlt",
    "body": "Währungs-Code ist ein Pflichtfeld.",
    "button": "Schliessen"
  },
  "Foreign currency amount must be a number": {
    "type": "error",
    "header": "Fremdwährungsbetrag muss eine Zahl sein",
    "body": "Fremdwährungsbetrag muss eine Zahl sein und darf keine Buchstaben enthalten.",
    "button": "Schliessen"
  },
  "Foreign exchange currency is required when a foreign currency amount is specified": {
    "type": "error",
    "header": "Fremdwährung und Fremdwährungsbetrag stimmen nicht überein",
    "body": "Wenn ein Fremdwährungsbetrag angegeben ist, muss auch eine Fremdwährung angegeben werden (sowie umgekehrt)",
    "button": "Schliessen"
  },
  "Currency code must be exactly 3 characters long": {
    "type": "error",
    "header": "Währungs-Code hat nicht die richtige Länge",
    "body": "Währungs-Code darf genau 3 Zeichen lang sein.",
    "button": "Schliessen"
  },
  "newPasswordSuccess": {
    "type": "success",
    "header": "Erfolg",
    "body": "Passwort erfolgreich geändert. Logge dich jetzt mit deinem neuen Passwort ein.",
    "button": "Schliessen"
  },
  "youAreAboutToDeleteTemplateTransactions": {
    "type": "warning",
    "header": "Daten werden gelöscht",
    "body": "Alle Mustertransaktionen werden löschen. Fortsetzen?",
    "button": "OK",
    "button2": "Abbrechen"
  },
  "infoRedirectToProvider": {
    "type": "info",
    "header": "Bank-Login",
    "body": [
      "Wir leiten dich auf eine sichere Webseite unseres Anbieters weiter. Bitte logge dich dort bei deiner Bank ein, um die Verbindung zu genehmigen.",
      "Nachdem du fertig bist, wirst du zu Monestry zurückgeleitet.",
      "Es ist möglich, dass du dich mehrmals einloggen musst, da es verschiedene Möglichkeiten gibt, auf die Daten deiner Bank zuzugreifen."
    ],
    "button": "OK",
    "button2": "Cancel"
  },
  "infoNoNewAccounts": {
    "type": "info",
    "header": "Keine neue Konten",
    "body": "Alle deine Konten aus dieser Bank sind bereits eingerichtet. Bitte wähle eine andere Bank.",
    "button": "OK"
  },
  "expiredCredentialsError": {
    "type": "info",
    "header": "Bank-Zugang abgelaufen",
    "body": [
      "Zugang für {{accountName}} muss erneuert werden. Klicke OK, um sich erneut bei der Bank einzuloggen.",
      "Wenn du mehr als ein Konto von dieser Bank verknüpft hast, musst du dies nur einmal tun."
    ],
    "button": "OK",
    "button2": "Abbrechen"
  },
  "signUpForNewsletter": {
    "type": "info",
    "header": "Danke für dein Interesse!",
    "body": [
      "Wir schicken dir in der Regel alle 1-2 Monate eine E-Mail über Neuigkeiten rund um Monestry.",
      "Du erhälst jetzt noch eine Bestätigungsemail. Abmeldung ist jederzeit möglich; ein Link dazu gibt es in der Email."
    ],
    "button": "OK",
    "button2": "Abbrechen"
  },
  "shareReportLinkSuccess": {
    "type": "success",
    "header": "Dein Link und Passcode",
    "button": "OK"
  },
  "renewAccountAccessNoIbansFound": {
    "type": "error",
    "header": "IBANs nicht gefunden",
    "body": [
      "Deine Bank hat uns folgende Konten (IBANs) mitgeteilt: {{providerIbans}}.",
      "Du hast jedoch in Monestry lediglich folgende ausländichen Konten mit automatischen Updates eingerichtet: {{monestryIbans}}.",
      "Bitte überprüfe, ob die IBANs in Monestry korrekt sind und füge fehlende Konten hinzu."
    ],
    "button": "OK"
  },
  "providerAccountsRemoved": {
    "type": "info",
    "header": "Konten entfernt",
    "body": [
      "Wir haben keine Daten für {{list}} von deiner Bank erhalten. Diese Konten scheinen entfernt worden zu sein.",
      "Wir haben sie in manuell verwalteten Konten umgewandelt."
    ],
    "button": "OK"
  },
  "aboutToReceiveRealEstateValuation": {
    "type": "info",
    "header": "Die erste Bewertung",
    "body": [
      "Wir sind dabei, den Wert deiner Immobilie zu berechnen. Stelle sicher, dass du alle dir bekannten Details auf dem vorherigen Bildschirm eingegeben hast, da dies sich auf die Genauigkeit der Bewertung auswirkt.",
      "Drücke OK, um zu bestätigen, oder Abbrechen, um abzubrechen."
    ],
    "button": "OK",
    "button2": "Abbrechen"
  },
  "errorsDetected": {
    "type": "error",
    "header": "Fehler entdeckt",
    "body": "Wir haben einige Fehler in deinen Daten gefunden. Bitte korrigiere sie, bevor du fortfährst.",
    "button": "OK"
  }
}
